import {ErrorCircleFilled} from "@fluentui/react-icons";
import {Column, Row} from "./Layout";
import {Image} from "@fluentui/react-components";
import failureIcon from "../../../assets/ver3/nbt/failure.png";
import {getCurrentSubDomain} from "../../HomePage";
import {useCommonPageStyles} from "../../../styles/mission/commonStyle";
import {useUserStore} from "../../../stores/useUserStore";
import {useEffect} from "react";
import {ShoppingPathJointEventIO} from "../../../io/content/shoppingPathJointEventIO";
import {EventType} from "../../../constant/EventType";

export function FailurePage() {

    const style= useCommonPageStyles()
    const currentSubDomain = getCurrentSubDomain();

    const userInfo = useUserStore();

    useEffect(()=>{
        ShoppingPathJointEventIO.post({
            shoppingPathJointId: userInfo.shoppingPathJointId,
            userId: userInfo.userId,
            misc: userInfo.misc,
            eventType: EventType.ShoppingRewardFailurePageLanding
        }).then(
            v =>{
                if(v){
                    console.log(v)
                    userInfo.resetUserData()
                }
            }
        ).catch(e => console.error(e))
    },[])

    if(currentSubDomain === "nbt" || currentSubDomain.includes("toktokquiz")){
        return <div className={style.nbt_root}>
            <Image alt={"failure_icon"} src={failureIcon}/>
            <div className={style.textStyle}>
                죄송합니다.<br/>
                <br/>
                정답을 제출해주셨으나 적립에 실패했습니다.<br/>
                다시 시도해주시길 부탁드립니다.<br />
                감사합니다.
            </div>
        </div>
    }
    else {
        return <Column gap={'16px'} alignItems={'center'} justifyContent={'center'}>
            <div style={{height:'96px'}} />
            <ErrorCircleFilled fontSize={'200px'}  color={'black'} />
            <Row>
                죄송합니다.
            </Row>
            <Row>
                정답을 제출해주셨으나 적립에 실패했습니다.<br/>
                다시 시도해주시길 부탁드립니다.<br />
                감사합니다.
            </Row>
        </Column>
    }


}